import React, { Component } from 'react';
import { connect } from 'react-redux';
import { editDayCard } from '../redux/actions/patchToDay';
import { closeSliderModal } from '../redux/actions/placesModalActions';
import { changeSlideWithNoLoadMore } from '../redux/actions/placesModalActions';
import { openLoginModal } from '../redux/actions/authActions';

export function withEditable(SliderComponent) {
  const mapStateToProps = state => {
    const { servicesModal } = state;
    const patchInfo = servicesModal.patchInfo;
    const route =
      patchInfo && state.schema.days.byId[patchInfo.dayNo].routes[patchInfo.index];
    const loadingCards = servicesModal.loading;
    return {
      patchInfo,
      route,
      loadingCards,
    };
  };

  const mapDispatchToProps = (dispatch, ownProps) => {
    const { themes, modalType, slideIndex, theme, toggleAlert, cardsArray } = ownProps;
    const slideTo = 0;

    return {
      addToDay: ({ cardData }) => {
        const isLodge = theme === 'lodges';
        if (isLodge) {
          const hasLodge =
            cardsArray.filter(card => card.poster_type === 'lodgings').length > 0;
          if (hasLodge) {
            toggleAlert(cardData);
          } else {
            return dispatch(editDayCard({ theme, cardData, editType: 'add' }));
          }
        } else {
          return dispatch(editDayCard({ theme, cardData, editType: 'add' }));
        }
      },
      removeFromDay: ({ cardData }) => {
        const isDayModal = modalType === 'dayModal';
        if (isDayModal) {
          const isLastCard = slideIndex === themes.length - 1;
          if (isLastCard) {
            const isSingleCard = themes.length === 1;
            if (isSingleCard) {
              dispatch(closeSliderModal());
            }
            dispatch(changeSlideWithNoLoadMore({ slideTo, slideIndex }));
          }
        }
        return dispatch(editDayCard({ theme, cardData, editType: 'remove' }));
      },
      openLoginModal: () => {
        setTimeout(() => dispatch(openLoginModal()), 500);
      },
    };
  };

  class SliderComponentForDay extends Component {
    render() {
      const { themes, slideIndex, patchInfo } = this.props;
      const editable = patchInfo && this.editable(themes[slideIndex].id);
      let newProps = {};

      newProps = {
        ...this.props,
        editable,
      };
      return <SliderComponent {...newProps} />;
    }

    editable = id => {
      const { addToDay, removeFromDay, route, loadingCards } = this.props;
      // const cardsArray = this.resolveCardsArray();
      let isLoading = false;
      const isAdded = route.posters.filter(card => card && card.id === id).length !== 0;

      const loadingCardIds = Object.keys(loadingCards);
      const hasLoadingId = loadingCardIds.filter(lodgeId => lodgeId === id).length !== 0;

      if (hasLoadingId) {
        isLoading = loadingCards[id];
      }
      if (!isAdded) {
        return {
          edit: addToDay,
          isAdded,
          isLoading,
        };
      } else {
        return {
          edit: removeFromDay,
          isAdded,
          isLoading,
        };
      }
    };
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(SliderComponentForDay);
}



// WEBPACK FOOTER //
// ./src/HOCs/withEditable.jsx